import { useMemo } from 'react';
/* eslint-disable no-redeclare */

var getUniqueId = function getUniqueId() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'id-';
  return prefix + Math.random().toString(16).slice(-4);
};

function useUniqueId(prefix) {
  var when = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return useMemo(function () {
    return when ? getUniqueId(prefix) : undefined;
  }, [prefix, when]);
}

export { getUniqueId, useUniqueId };